import initSubscribeForm from '~scripts/blocks/subscribe-form';

const subscribeForm = document.querySelector('.event-video #subscribeForm');
const videoFormWrapper = document.querySelector('.js-event-video__form');
const eventVideo = document.getElementById('eventVideo');
const formExist = !!videoFormWrapper;

if (formExist) {
  initSubscribeForm(subscribeForm);
}

if (eventVideo?.querySelector('.js-vk-video')) {
    import('./event-video-vk');
}

if (eventVideo?.querySelector('.js-yt-video')) {
    import('./event-video-youtube');
}